define('viewModels/widgets/SortableList',[
    'viewModels/ViewModel',
    'lib/knockout',
    'lib/lodash4'
], function (ViewModel, ko, _) {
    "use strict";

    /**
     * A control for a multi-selectable orderable list of items.
     *
     * source - The enumeration of all possible values.
     * destination - The destination array of selected values.
     * options - The configuration options.
     *
     * options.sourceLabelProperty - If the possible values are an object, the property to use as a display label (OPTIONAL). For example, this might be a "name" property.
     * options.comparatorProperty - If specified only that enum property will be put in the destination array when an item is selected (OPTIONAL). For example this might be an "id" property.
     * options.destinationValueProperty - If specified only that enum property will be put in the destination array when an item is selected (OPTIONAL). For example this might be an "id" property.
     *
     */
    var SortableList = ViewModel.extend(function (
        source,
        destination,
        options
    ) {
        var self = this;
        options = _.assign({}, options);

        var findItemIndex = function (item) {
            return _.findIndex(destination(), function (currentValue) {
                if (options.comparatorProperty) {
                    return item.value[options.comparatorProperty] === currentValue[options.comparatorProperty];
                }
                return item.value === currentValue;
            });
        };

        self.items = ko.computed(function () {
            var itemArray = _.map(source, function (enumValue) {
                var label = enumValue;
                if (options.sourceLabelProperty) {
                    label = enumValue[options.sourceLabelProperty];
                }

                var value = enumValue;
                if (options.destinationValueProperty) {
                    value = enumValue[options.destinationValueProperty];
                }

                var item =  {
                    label: label,
                    value: value
                };

                item.isSelected = findItemIndex(item) > -1 ? true : false;

                return item;
            });

            return _.sortBy(itemArray, [function (item) {
                var indexInValueAccessor = findItemIndex(item);
                if (indexInValueAccessor > -1) {
                    return indexInValueAccessor;
                }
                return itemArray.length;
            }]);
        });

        self.toggleItem = function (item) {
            var indexInValueAccessor = findItemIndex(item);
            if (indexInValueAccessor > -1) {
                destination.splice(indexInValueAccessor, 1);
            }
            else {
                destination.push(item.value);
            }
        };

        self.promoteItem = function (item) {
            var index = findItemIndex(item);
            if (index > 0) {
                destination.splice(index - 1, 0, destination.splice(index, 1)[0]);
            }
        };

        self.demoteItem = function (item) {
            var index = findItemIndex(item);
            if (index < destination().length - 1) {
                destination.splice(index + 1, 0, destination.splice(index, 1)[0]);
            }
        };

        self.validator = destination;

    }, true);

    return SortableList;
});
